import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Link, Typography } from '@mui/material';
// routes
import { PATH_AUTH } from '../../routes/paths';
// components
import Iconify from '../../components/iconify';
// sections
// assets
import { PasswordIcon } from '../../assets/icons';
import AuthNewPasswordForm from '../../sections/auth/AuthNewPassword';

// ----------------------------------------------------------------------

export default function VerifyOtp() {
  return (
    <>
      <Helmet>
        <title> {` New password | ${process.env.REACT_APP_NAME} `}</title>
      </Helmet>

      <PasswordIcon sx={{ mb: 5, height: 96 }} />

      <Typography variant="h3" paragraph>
        Enter new password
      </Typography>

      <Typography sx={{ color: 'text.secondary', mb: 5 }}>
        This password only use after successfully password change
      </Typography>

      <AuthNewPasswordForm />
      <Link
        component={RouterLink}
        to={PATH_AUTH.login}
        color="inherit"
        variant="subtitle2"
        sx={{
          mt: 3,
          mx: 'auto',
          alignItems: 'center',
          display: 'inline-flex',
        }}
      >
        <Iconify icon="eva:chevron-left-fill" width={16} />
        Return to sign in
      </Link>
    </>
  );
}
